export const STRUCTURED_LOGS_FLAG = 'structured_logs_office'

export const isStructuredLogsEnabled = (flag?: { enabled?: boolean }) =>
  Boolean(flag?.enabled)
